import { useFetchUserPermissionsQuery } from '@backrs_ui/grow-ui/src/redux/user/user.api';
import { UI_PERMISSIONS } from '@backrs_ui/grow-ui/src/redux/user/user.transformer';
import { IS_SANDBOX } from '@backrs_ui/grow-ui/src/utils/sandboxSession';

/** Coaches and every sandbox visitor; undefined while permissions load. */
export const useCanViewBenchmarks = (): boolean | undefined => {
  const { data: userPermissions, isError } = useFetchUserPermissionsQuery(undefined, {
    skip: IS_SANDBOX,
  });

  if (IS_SANDBOX) return true;
  if (isError) return false;

  return userPermissions?.[UI_PERMISSIONS.ACCESS_COACH_DASHBOARD].allowed;
};
